module.exports = __webpack_public_path__ + "img/X7.f293be05.png";